module.exports = __webpack_public_path__ + "static/media/ic-caret-down2.fb910154.svg";